import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { Report } from '@/modules/reports/shared/domain/report';
import { ReportRegistryView } from '@/modules/reports/management/domain/report-registry.view';
import axios from 'axios';
import { DatacenterEquipments } from '@/modules/reports/shared/domain/datacenter-equipments';

class ReportsRepository extends HttpRepository {
    private static readonly RESOURCE = 'reports';

    /**
     * Permite obtener todas las métricas que son visualizadas desde el
     * dashboard de reportes.
     */
    async getReportsDashboard() {
        return (
            await this.get(
                this.createUri(['views', 'dashboard', `${ReportsRepository.RESOURCE}`]),
                this.createAuthorizationHeader(),
            )
        ).data.values;
    }

    /**
     * Obtiene los reportes registrados para el data center especificado
     * y el parámetro especificado
     * @param buildingId  id de los data centers de los cuales se desea obtener
     *                    los reportes registrados. Ejemplo: DC 1-1, DC MZ.
     * @param parameterId id del parámetro del cual se desea obtener los
     *                    reportes. Ejemplo: Temperatura, Humedad.
     */
    getBuildingsReports(buildingId: number, parameterId: number) {
        return this.get(
            this.createUri([
                `${ReportsRepository.RESOURCE}`,
                'buildings',
                buildingId,
                'parameters',
                parameterId,
            ]),
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Obtiene los datos para la generación de reportes
     */
    async getInfoReports(): Promise<ReportRegistryView> {
        return (
            await this.get(
                this.createUri(['views', ReportsRepository.RESOURCE]),
                this.createAuthorizationHeader(),
            )
        ).data.values;
    }

    /**
     * Crea reportes de disponibilad en lote
     */
    async createAvailabilityReport(reportData: Report[]) {
        return this.post(
            this.createUri([`${ReportsRepository.RESOURCE}`]),
            reportData,
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Lista los reportes de disponibilidad existentes
     */
    async listReports(options: { limit: number; start: number }) {
        return this.get(
            this.createUri([
                `${ReportsRepository.RESOURCE}?limit=${options.limit}&start=${options.start}`,
            ]),
            this.createAuthorizationHeader(),
        );
    }

    /**
     * Descarga el reporte de disponibilidad mensual
     */
    async getMonthlyReport(data: { month: string; year: string; dataCenter: number }) {
        return this.get(
            this.createUri([
                `${ReportsRepository.RESOURCE}/monthly-report?dataCenterId=${data.dataCenter}&year=${data.year}&month=${data.month}`,
            ]),
            this.createAuthorizationDocumentsHeader(),
        );
    }

    /**
     * Obtiene los datacenters disponibles
     */
    async getDataCentersAndBuildings(): Promise<DatacenterEquipments[]> {
        return (
            await this.get(
                `${ReportsRepository.RESOURCE}/data-centers`,
                this.createAuthorizationHeader(),
            )
        ).data;
    }
}

export default new ReportsRepository();
